import userConstants from '../../constants/userConstants';

export const MY_JL_MEMBER_LOYALTY_TYPES = [
  userConstants.LOYALTY_MY_JL,
  userConstants.LOYALTY_PARTNERSHIP,
];

export const isMyJLMember = (loyaltyType: string) => MY_JL_MEMBER_LOYALTY_TYPES.includes(loyaltyType);
